import LayoutActividad from "../../../components/LayoutActividad";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { modulo9 } from "../../../routes/Module9";
import { modulo10 } from "../../../routes/Module10";
import Sidebar from "../Sidebar";
import { faSignLanguage } from "@fortawesome/free-solid-svg-icons";
import Imagen1 from "../../../images/modulo9/bibliotecas.png";
import Imagen2 from "../../../images/modulo9/pediatra.png";
import Imagen3 from "../../../images/modulo9/bus.png";
import Imagen4 from "../../../images/modulo9/parque.png";
import GuiaDocente from "../../../components/GuiaDocente";
import Modulo9Act9 from "../../../DnD/modulo9Act9";
import AudioPlayer from "../../../audioPlayer/AudioPlayer";
import Audio from "../../../audios/modulo9/Actividad 7.mp3";

const Actividad9 = () => {
  const infoUnidad = modulo9.content[0];
  const infoAct = modulo9.content[0].activities[6];
  const crumbs = [
    {
      title: modulo9.title,
      url: "/" + modulo9.url,
    },
    {
      title:
        modulo9.content.length === 1
          ? `${infoAct.name}`
          : `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];
  const pages = {
    titlePrev: `${modulo9.content[0].activities[5].name}`,
    linkPrev: `${modulo9.url}/${modulo9.content[0].path}/${modulo9.content[0].activities[5].path}`,
  };
  const metadata = {
    color: modulo9.color,
    title: `${modulo9.title} - ${infoAct.name}`,
    name: modulo9.title,
  };

  const items = [
    <div>
      <img src={Imagen1} alt="Electores" className="img-fluid" />
      <p className="p-3 m-0">
        <strong>
          Todas las escuelas deben tener bibliotecas con muchos libros y
          computadoras.
        </strong>
      </p>
    </div>,
    <div>
      <img src={Imagen2} alt="Electores" className="img-fluid" />
      <p className="p-3 m-0">
        <strong>
          Debe haber médicos especialistas en niños y niñas en todos los pueblos
          y barrios.
        </strong>
      </p>
    </div>,
    <div>
      <img src={Imagen3} alt="Electores" className="img-fluid" />
      <p className="p-3 mb-3">
        <strong>El transporte público debe ser seguro y puntual.</strong>
      </p>
    </div>,
    <div>
      <img src={Imagen4} alt="Electores" className="img-fluid" />
      <p className="p-3 mb-3">
        <strong>
          Debe haber más parques y plazas con juegos para niños y niñas.
        </strong>
      </p>
    </div>,
  ];

  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <p>
        <small className={`c-${modulo9.color} hat-text`}>
          <FontAwesomeIcon icon={faSignLanguage} /> Hacemos
        </small>
      </p>

      <h2 className="mb-5">{infoAct.name}</h2>
          <AudioPlayer track={Audio} />

      <ul className="mb-2">
        <li>
          El jefe de los ministros es el presidente del Consejo de Ministros.
          Imagina que le envías una carta con recomendaciones para mejorar la
          situación de niños y niñas.
        </li>
        <li>
          Trabaja con un compañero, compañera o familiar. Arrastra las imagenes
          en los recuadros numerados del 1 al 4 en las siguientes
          recomendaciones: la 1 es la que les parece más importante y la 4 es la
          menos importante.
        </li>
        <li>Cuando termines, explica tus decisiones.</li>
      </ul>

      <Modulo9Act9 items={items} />

      <GuiaDocente>
        <p>
          Lea las indicaciones. Lean cada una de las recomendaciones y describan
          las imágenes. Pregunte por la justificación de las decisiones tomadas.
          Todas las respuestas son válidas porque están dirigidas a mejorar la
          situación de todos los niños y niñas.
        </p>
      </GuiaDocente>
      <div className="unit-options my-5 d-flex flex-column">
        <p>Ir al siguiente módulo:</p>
        <a href={"/" + modulo10.url}>
          <button className={`btn btn-${modulo9.color} me-2`}>
            {modulo10.title + " >"}
          </button>
        </a>
      </div>
    </LayoutActividad>
  );
};

export default Actividad9;
